import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check } from 'lucide-react';
export function CerebroDigital() {
  const comparisons = [{
    task: 'Buscar archivos',
    without: '10 min',
    with: '10 segundos'
  }, {
    task: 'Enviar plan',
    without: 'adjuntar y escribir',
    with: 'Un solo clic con link Drive'
  }, {
    task: 'No sabés quién no volvió',
    without: 'Revisar agenda manual',
    with: 'Semáforo automático en tu planilla'
  }, {
    task: 'Responder precio',
    without: 'desde cero',
    with: 'Respuesta rápida guardada'
  }, {
    task: 'Finanzas',
    without: 'papeles y memoria',
    with: 'Tablero actualizado en tiempo real'
  }];
  return <section className="py-6 px-4 max-w-3xl mx-auto" data-id="element-50">
      <FadeIn data-id="element-51">
        <h2 className="text-xl md:text-2xl font-bold text-center mb-5 flex items-center justify-center gap-2" data-id="element-52">
          <span className="text-2xl" data-id="element-53">🧠</span> ¿QUÉ AGREGA EL CEREBRO DIGITAL?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden" data-id="element-54">
          <div className="grid grid-cols-3 bg-gray-800/80 border-b border-gray-700 p-2.5 font-bold text-xs md:text-sm" data-id="element-55">
            <div className="text-gray-400" data-id="element-56">Situación</div>
            <div className="text-red-400 text-center" data-id="element-57">Sin Cerebro Digital</div>
            <div className="text-green-400 text-center" data-id="element-58">
              Con Cerebro Digital
            </div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-59">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-2.5 items-center text-xs md:text-sm hover:bg-gray-800/30 transition-colors" data-id="element-60">
                <div className="font-medium text-gray-300 pr-2" data-id="element-61">
                  {item.task}
                </div>
                <div className="text-center text-gray-400 flex flex-col items-center gap-0.5" data-id="element-62">
                  <X size={14} className="text-red-500/50" data-id="element-63" />
                  <span data-id="element-64">{item.without}</span>
                </div>
                <div className="text-center font-bold text-green-400 flex flex-col items-center gap-0.5 bg-green-900/10 py-1.5 rounded-lg" data-id="element-65">
                  <Check size={14} className="text-green-500" data-id="element-66" />
                  <span data-id="element-67">{item.with}</span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-5 text-center" data-id="element-68">
          <p className="text-base font-bold text-gray-200 mb-1" data-id="element-69">
            7 módulos · Drive · WhatsApp Business · ChatGPT · Finanzas
          </p>
          <p className="text-green-400 font-medium text-sm" data-id="element-70">
            Plan de implementación en 48 horas incluido
          </p>
        </div>
      </FadeIn>
    </section>;
}